import React from "react";
import "../styles/Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      {/* Background overlay layer */}
      <div className="footer-overlay"></div>

      <div className="footer-sections">
        <div className="footer-section">
          <h3>Our Services</h3>
          <ul>
            <li>Quality Used Vehicle Spares</li>
            <li>Nationwide Deliveries</li>
            <li>Towing & Recovery</li>
            <li>Roadside Assistance</li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Trading Hours</h3>
          <p>Mon - Fri: 07:30 - 17:00</p>
          <p>Sat - Public Holidays: 08:00 - 13:00</p>
        </div>

        <div className="footer-section">
          <h3>Contact Us</h3>
          <p>Tel: 041-023-0241</p>
          <p>
            Email:{" "}
            <a href="mailto:info@autoimperium.co.za">info@autoimperium.co.za</a>
          </p>
        </div>

        <div className="footer-section">
          <h3>Our Branches</h3>
          <p>304 Kempston Road, Holland Park, Port Elizabeth, 6001</p>
          <p>81 Haupt Street, Sidwell, Port Elizabeth, 6061</p>
        </div>
      </div>

      {/* Centered Company Logo */}
      <div className="footer-logo">
        <img
          src={`${process.env.PUBLIC_URL}/ImperiumLogo.png`}
          alt="Imperium Auto Group Logo"
        />
      </div>

      {/* Horizontal Line and Copyright */}
      <div className="footer-bottom">
        <hr className="footer-line" />
        <p>© 2022 Imperium Auto Group. Built by Dane Iverson</p>
      </div>
    </footer>
  );
};

export default Footer;
